import SUBDOMAIN_ID_MAP from '../models/subdomainIdMap';
/**
 * Returns the carrierId and producerId based on the current subdomain
 * @example getCarrierAndProducerIds();
 * // returns { carrierId: 'wrb-7uhb1rfllu8x8ul2' }
 * @returns {Object} - Object containing the carrierId and producerId
 */

const LOCALHOST_CARRIER_ID = SUBDOMAIN_ID_MAP.berkleyah;

function getCarrierAndProducerIds() {
	const { hostname } = window.location;
	// the subdomain we want to check is the first part of the hostname
	const subdomain = hostname.split('.')[0]?.toLowerCase();
	if (subdomain === 'localhost') {
		return LOCALHOST_CARRIER_ID;
	}
	return SUBDOMAIN_ID_MAP[subdomain];
}

export default getCarrierAndProducerIds;
